import type { WorkRole, SystemRole, UserWorkContext } from '@entities/user';

/**
 * Map backend role string (e.g. AccountAdmin, User, TechnicalManager) to frontend WorkRole and SystemRole.
 * Used for impersonation context so UI permission checks match the impersonated user.
 */
export function backendRoleToWorkContext(role: string): { work_role: WorkRole; system_role: SystemRole } {
  switch (role) {
    case 'AccountAdmin':
      return { work_role: 'BRANCH_USER', system_role: 'ACCOUNT_ADMIN' };
    case 'TechnicalManager':
      return { work_role: 'TECH_MANAGER', system_role: 'NORMAL_USER' };
    case 'TechnicalUser':
      return { work_role: 'TECHNICIAN', system_role: 'NORMAL_USER' };
    case 'LocationUser':
      return { work_role: 'BRANCH_USER', system_role: 'NORMAL_USER' };
    case 'User':
    default:
      return { work_role: 'BRANCH_USER', system_role: 'NORMAL_USER' };
  }
}

/**
 * Map impersonation work context back to backend role string.
 * Used so sidebar and permission checks use the effective (impersonated) role.
 */
export function workContextToBackendRole(ctx: UserWorkContext | null): string | null {
  if (!ctx) return null;
  if (ctx.backendRole) return ctx.backendRole;
  if (ctx.system_role === 'SYSTEM_ADMIN') return 'SystemAdmin';
  if (ctx.system_role === 'ACCOUNT_ADMIN') return 'AccountAdmin';
  if (ctx.work_role === 'TECH_MANAGER') return 'TechnicalManager';
  if (ctx.work_role === 'TECHNICIAN') return 'TechnicalUser';
  if (ctx.work_role === 'BRANCH_USER') return 'User';
  return 'User';
}
